import ReplyAll from "./ReplyAll";

export * from "./Container";
export * from "./Forward";
export * from "./Mailbox";
export * from "./MailCheck";
export * from "./MailMinus";
export * from "./MailPlus";
export * from "./MailQuestion";
export * from "./Mails";
export * from "./MailSearch";
export * from "./MailWarning";
export * from "./MailX";
export * from "./Reply";
export * from "./ReplyAll";

export const Mailss = {
  ReplyAll,
};
